import { cn } from "~/lib/utils";
import { projectPriorityIcon } from "./projectsModel";

export interface PriorityIconProps {
  readonly priority: string | null | undefined;
  readonly className?: string;
}

/**
 * Jira-style priority indicator: a colored chevron/equals icon with a tooltip
 * and accessible label (e.g. "Priority: High"). Renders nothing for an
 * unknown/empty priority so callers can drop it inline without guards.
 */
export function PriorityIcon({ priority, className }: PriorityIconProps) {
  const descriptor = projectPriorityIcon(priority);
  if (!descriptor) return null;
  const { Icon, colorClass, label } = descriptor;
  const title = `Priority: ${label}`;
  return (
    <span
      role="img"
      aria-label={title}
      title={title}
      className={cn("inline-flex shrink-0 items-center", colorClass, className)}
    >
      <Icon className="size-4" aria-hidden />
    </span>
  );
}
